import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  TextField,
  MenuItem,
  Button,
  AppBar,
  Toolbar,
  Alert,
} from "@mui/material";

const insuranceTypes = [
  { value: "motor", label: "Motor Insurance" },
  { value: "health", label: "Health Insurance" },
  { value: "fire", label: "Fire Insurance" },
  { value: "travel", label: "Travel Insurance" },
];

const RefundApplication = () => {
  const [formData, setFormData] = useState({
    insuranceType: "",
    certificateNo: "",
    reason: "",
    email: "",
    name: "",
    file: null,
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    if (e.target.name === "file") {
      setFormData({ ...formData, file: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const formPayload = new FormData();

      formPayload.append("insuranceType", formData.insuranceType);
      formPayload.append("certificateNo", formData.certificateNo);
      formPayload.append("name", formData.name);
      formPayload.append("email", formData.email);
      formPayload.append("reason", formData.reason);

      if (formData.file) {
        formPayload.append("file", formData.file);
      }

      const response = await fetch(
        "https://www.bgicdigital.com/admin/refund.php",
        {
          method: "POST",
          body: formPayload,
        }
      );

      const data = await response.json();

      if (data.success) {
        setSuccessMsg("Refund application submitted successfully!");

        setFormData({
          insuranceType: "",
          certificateNo: "",
          reason: "",
          email: "",
          name: "",
          file: null,
        });
      } else {
        setErrorMsg("Failed to submit application. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setErrorMsg("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5, mb: 5 }}>
      {/* Header */}
      <AppBar position="static">
        <Toolbar sx={{ justifyContent: "center" }}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" fontWeight={600}>
              BGIC Digital Store
            </Typography>
          </a>
        </Toolbar>
      </AppBar>

      <Typography variant="h4" textAlign="center" gutterBottom sx={{ mt: 3 }}>
        Refund Application
      </Typography>

      {successMsg && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMsg}
        </Alert>
      )}

      {errorMsg && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMsg}
        </Alert>
      )}

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <TextField
          select
          label="Insurance Type"
          name="insuranceType"
          value={formData.insuranceType}
          onChange={handleChange}
          required
        >
          {insuranceTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Certificate No"
          name="certificateNo"
          value={formData.certificateNo}
          onChange={handleChange}
          required
        />

        <TextField
          label="Full Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <TextField
          label="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <TextField
          label="Reason for Refund"
          name="reason"
          value={formData.reason}
          onChange={handleChange}
          required
          multiline
          rows={4}
        />

        {/* File Upload */}
        <Button variant="outlined" component="label">
          Upload Visa Refusal Letter
          <input
            type="file"
            name="file"
            hidden
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleChange}
          />
        </Button>

        {formData.file && (
          <Typography variant="body2">
            Selected file: {formData.file.name}
          </Typography>
        )}

        <Button type="submit" variant="contained" disabled={loading}>
          {loading ? "Submitting..." : "Submit Application"}
        </Button>
      </Box>
    </Container>
  );
};

export default RefundApplication;